<template>
  <div class="columns is-mobile">
    <div class="column">
      <div class="columns">
        <div class="column">
          <b-field label="Has employer been informed of alleged injury claim?" expanded>
            <b-switch
              v-model="fnoldata.employer.empInformed"
              true-value="Yes"
              false-value="No"
              ref="Employer Informed"
            >{{ fnoldata.employer.empInformed }}</b-switch>
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Date of Employer's Knowledge/Notice of Injury"
            expanded
            :type="{'is-danger': errors.has('dateReportedToEmployer')}"
            :message="errors.first('dateReportedToEmployer')"
          >
            <b-datepicker
              name="dateReportedToEmployer"
              placeholder="Click to select..."
              icon="calendar-today"
              v-model="fnoldata.injury.dateReportedToEmployer"
              v-validate.immediate="'required_if:Employer Informed,Yes'"
              data-vv-as="Date"
            >
            <button class="button is-warning"
                @click="fnoldata.injury.dateReportedToEmployer = new Date()">
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
            </button>
            <button class="button is-warning"
                @click="fnoldata.injury.dateReportedToEmployer = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <b-field
        label="Employer Name"
        :type="{'is-danger': errors.has('employer.employername')}"
        :message="errors.first('employer.employername')"
      >
        <b-input
          v-model="fnoldata.employer.name"
          name="employername"
          v-validate="'required|alpha_spaces'"
          data-vv-as="Employer Name"
          data-vv-scope="employer"
        />
      </b-field>
      <b-field
        label="Mailing Address"
        :type="{'is-danger': errors.has('employer.mailingaddress')}"
        :message="errors.first('employer.mailingaddress')"
      >
        <b-input
          v-model="fnoldata.employer.address.street"
          name="mailingaddress"
          v-validate="'required'"
          data-vv-as="Address"
          data-vv-scope="employer"
        />
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field
            label="City"
            :type="{'is-danger': errors.has('employer.city')}"
            :message="errors.first('employer.city')"
            expanded
          >
            <b-input
              v-model="fnoldata.employer.address.city"
              name="city"
              v-validate="'required'"
              data-vv-as="City"
              data-vv-scope="employer"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="State"
            expanded
            :type="{'is-danger': errors.has('employer.state')}"
            :message="errors.first('employer.state')"
          >
            <b-select
              v-model="fnoldata.employer.address.state"
              placeholder="Please select"
              name="state"
              expanded
              v-validate="'required'"
              data-vv-as="State"
              data-vv-scope="employer"
            >
              <option v-for="(key, value) in stateMap" :value="value" :key="value">{{ key }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Zip code"
            :type="{'is-danger': errors.has('employer.zipcode')}"
            :message="errors.first('employer.zipcode')"
          >
            <b-input
              v-model="fnoldata.employer.address.zip"
              name="zipcode"
              v-validate="{ required: true, regex:/^\d{5}(-\d{4})?$/ }"
              data-vv-as="Zip code"
              data-vv-scope="employer"
              maxlength="10"
            />
          </b-field>
        </div>
      </div>

      <b-collapse :open="false" aria-id="differentaddress">
        <b-field
          label="Is injury accident location different than mailing address?"
          slot="trigger"
          aria-controls="differentaddress"
          expanded
        >
          <b-switch
            v-model="fnoldata.injury.onEmployerPremises"
            true-value="Yes"
            false-value="No"
          >{{ fnoldata.injury.onEmployerPremises }}</b-switch>
        </b-field>
        <br />
        <div class="content" aria-controls="differentaddress">
          <b-field label="Location where Event or Exposure Occurred (Number,Street,City,Zip)">
            <b-input
              maxlength="100"
              type="textarea"
              v-model="fnoldata.injury.locationEventOccured"
              name="accidentlocation"
            ></b-input>
          </b-field>
        </div>
      </b-collapse>
      <br />
      <div class="columns">
        <div class="column">
          <b-field
            label="Phone"
            :type="{'is-danger': errors.has('employer.phone')}"
            :message="errors.first('employer.phone')"
            expanded
          >
            <b-input
              v-model="employerPhone"
              name="phone"
              v-validate="'required|min:16'"
              data-vv-as="Phone"
              data-vv-scope="employer"
              maxlength="16"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Fax"
            :type="{'is-danger': errors.has('employer.fax')}"
            :message="errors.first('employer.fax')"
            expanded
          >
            <b-input
              v-model="employerFax"
              v-validate="'min:16'"
              data-vv-as="fax"
              data-vv-scope="employer"
              name="fax"
              maxlength="16"
            />
          </b-field>
        </div>
      </div>
      <b-field
        label="Employer contact name"
        :type="{'is-danger': errors.has('employer.empcontactname')}"
        :message="errors.first('employer.empcontactname')"
        expanded
      >
        <b-input
          v-model="fnoldata.employer.contactName"
          name="empcontactname"
          v-validate="'required|alpha_spaces'"
          data-vv-as="Contact Name"
          data-vv-scope="employer"
        />
      </b-field>
      <b-field
        label="Email"
        :type="{'is-danger': errors.has('employer.email')}"
        :message="errors.first('employer.email')"
        expanded
      >
        <b-input
          type="email"
          icon="email"
          v-model="fnoldata.employer.email"
          name="email"
          v-validate="'email'"
          data-vv-as="Email"
          maxlength="30"
          data-vv-scope="employer"
        />
      </b-field>
    </div>
  </div>
</template>
<script>
import TypeLists from "../data/typelists";
import { PhoneFormatter, ZipFormatter } from "../utils/util";

export default {
  props: ["fnoldata"],
  name: "EmployerInfo",
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator;
  },
  data() {
    return {
      stateMap: TypeLists.StatesFiltered,
      employerPhone: PhoneFormatter(this.fnoldata.employer.phone.work),
      employerFax: PhoneFormatter(this.fnoldata.employer.phone.fax)
    };
  },
  watch: {
    employerPhone: function(input) {
      //alert(input);
      input = PhoneFormatter(input);
      this.employerPhone = input;
      this.fnoldata.employer.phone.work = input.replace(/[^\d.]/g, "");
    },
    employerFax: function(input) {
      //alert(input);
      input = PhoneFormatter(input);
      this.employerFax = input;
      this.fnoldata.employer.phone.fax = input.replace(/[^\d.]/g, "");
    },
    "fnoldata.employer.address.zip": function(input) {
      input = ZipFormatter(input);
      this.fnoldata.employer.address.zip = input;
    }
  }
};
</script>

